import { Injectable, NgZone } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore, AngularFirestoreDocument,QuerySnapshot, QueryDocumentSnapshot } from '@angular/fire/compat/firestore';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { take, map, switchMap, catchError } from 'rxjs/operators';
import { Subject, Observable,combineLatest, of, throwError, from } from 'rxjs';
import { HelperService } from 'src/app/core/services/helper.service';
import { AuthService } from 'src/app/core/services/api-services/auth.service';
import { environment } from 'src/environments/environment';
import { Timestamp } from '@firebase/firestore-types';
import firebase from 'firebase/compat/app';
import { getFirestore, Firestore } from 'firebase/firestore/lite';
import { cloneDeep } from 'lodash';


interface Message {
  userId: string; // Adjust the type according to your actual message structure
  // Add other properties as needed
}

@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  userData: any;
  private endPaginate = false;
  private queryCursor: any; // Type should be adjusted based on your Firestore document structure
  private limit = 10;
  tenant: any = localStorage.getItem('tenant')   
  /** Dashboard lists + per-user thread (`getChatMessages` / `loadMoreChatMessages`) only include messages on or after this instant. */
  private readonly activeChatsMinCreatedAt = new Date('2026-01-01T00:00:00.000Z');
  //lastVisibleMessageSr : any;

  postObj = {
    id: '',
    message: '',
    fromAdmin: false,
    isRead: false,
    isSent: true,
    type: 0,
    created_at: new Date(),
    fcmToken: '',
    userId: 0,
    userUid: '',
  };
  collectionName : any = {
    RenewRefill : 'RenewRefill',
    AdminNotifications : 'AdminNotifications',
    Chats : 'Chats'
  }
  currentMessage: any;
  messages: any;
  hospitalsArray: any;
  renewRefillList: Subject<Array<Record<string, any>>> = new Subject<
    Array<Record<string, any>>
  >();
  subscription: any;
  abc123: any = 1;
  constructor(
    private angularFireDB: AngularFireDatabase,
    private afAuth: AngularFireAuth,
    public helperService: HelperService,
    public authService: AuthService,
    private angularFireMessaging: AngularFireMessaging,
    private firestore: AngularFirestore,
    public ngZone: NgZone
  ) {
    this.userData = this.authService.userData;
    if(this.tenant == 'qc' || this.tenant == 'ml_qc' || this.tenant == 'pl_qc') {
      this.collectionName = {
        RenewRefill : 'RenewRefill_QC',
        AdminNotifications : 'AdminNotifications_QC',
        Chats : 'Chats_QC'
      }
    }
    this.updateObj();
  }
  printDatabaseName(): void {
    const firestore: Firestore = getFirestore(); // Use getFirestore() to get the Firestore instance
    const app = firestore.app; // Access the app property of the Firestore instance
    const firebaseOptions = app.options;
    console.log('Database name:', firebaseOptions);
  }
  updateObj() {
    this.authService.user.subscribe((user) => {
      if (user) {
        this.userData = user;
        this.postObj.fcmToken = user.firebase_token;
        this.postObj.userId = user.user.id;
        this.postObj.userUid = user.firebaseUserId;
      }
    });
  }

  /*** Get RenewRefill data from firebase ***/
 getRenewRefillHeader() {
    const ref = this.firestore.collection(
      this.collectionName.RenewRefill,
      ref =>
        ref
          .where('acknowledge_by', '==', '')
          .where('request_type', 'not-in', ['renew', 'refill'])
          .orderBy('created_at', 'desc')
          .limit(100)
    );

    return ref.snapshotChanges();
  }

  getRenewRefill() {
    const ref = this.firestore.collection(
      this.collectionName.RenewRefill,
      ref =>
        ref
          .where('acknowledge_by', '==', '')
          .where('request_type', 'not-in', ['renew', 'refill'])
          .orderBy('created_at', 'desc')
          .limit(100)
    );

    return ref.snapshotChanges();
  }

  getRenewRefillForPage() {
    let ref = this.firestore.collection(this.collectionName.RenewRefill, (ref) =>
      ref.orderBy('created_at', 'desc')
    );
    return ref.snapshotChanges();
  }

  /*** update RenewRefill data from firebase ***/
  updateRenewRefill(itme: any) {
    let currentDate = new Date();
    let convertDate =
      this.helperService.convertDashDate(currentDate) +
      ', ' +
      this.helperService.getTime(currentDate);
    this.firestore.collection(this.collectionName.RenewRefill).doc(itme.id).update({
      acknowledge_by: itme.updatedByUserName,
      updatedBy: convertDate,
    });
  }

  /*** Get AdminNotifications data from firebase ***/
  getAdminNotificationsForHeader() {
    let ref = this.firestore.collection(this.collectionName.AdminNotifications, (ref) =>
      ref
        .where('type', 'in', [
          'multiple_profile_management',
          'new_user_registration',
          'add_new_child',
        ])
        .where('acknowledge_admin_id', '==', '').limit(100)
    );
    return ref.snapshotChanges();
  }

  // Get messaging service
  getAdminNotifyMsgForheader() {
    return this.firestore.collection(this.collectionName.AdminNotifications, ref =>
      ref.where('type', 'in', [
        'update_profile',
        'addCard',
        'payment_method_add',
        'removeCard',
        'deletion_request',
        'addAllergy',
        'removeAllergy',
        'tasks',
        'profile_update',
        'medical_condition',
        'allergy',
        'referral_code',
        'preferences',
        'health_card',
        'payment_method_delete'
      ])
       .where('acknowledge_admin_id', '==', '').orderBy('created_at', 'desc')
       .limit(100) // Limit the results to 100 notifications
    ).snapshotChanges();
  }

  getAdminNotifyMsg() {
    let ref = this.firestore.collection(this.collectionName.AdminNotifications, (ref) =>
      ref
        .where('type', 'in', [
          'update_profile',
          'addCard',
          'payment_method_add',
          'removeCard',
          'deletion_request',
          'addAllergy',
          'removeAllergy',
          'tasks',
          'profile_update',
          'medical_condition',
          'allergy',
          'referral_code',
          'preferences',
          'health_card',
          'payment_method_delete'
        ])
        .where('acknowledge_admin_id', '==', '').orderBy('created_at', 'desc').limit(100)
    );
    return ref.snapshotChanges();
  }
  getAdminNotifyMsgForPage() {
    let ref = this.firestore.collection(this.collectionName.AdminNotifications, (ref) =>
      ref
        .where('type', 'in', [
          'update_profile',
          'addCard',
          'payment_method_add',
          'removeCard',
          'deletion_request',
          'addAllergy',
          'removeAllergy',
          'tasks',
          'profile_update',
          'medical_condition',
          'allergy',
          'referral_code',
          'preferences'
        ])
        .where('acknowledge_admin_id', '==', '')
    );
    return ref.snapshotChanges();
  }



  // get notification for order

  getOrderNotificationHeader() {
    let ref = this.firestore.collection(this.collectionName.AdminNotifications, (ref) =>
      ref.where('type', 'in', ['order', 'mark_default_address', 'benefit', 'update_benefits_auto', 'update_benefits_manual', 'private_insurance'])
         .where('acknowledge_admin_id', '==', '').limit(100)
    );
    return ref.snapshotChanges();
}


  getOrderNotification() {
    let ref = this.firestore.collection(this.collectionName.AdminNotifications, (ref) =>
      ref.where('type', 'in', ['order', 'mark_default_address', 'benefit', 'update_benefits_auto', 'update_benefits_manual', 'private_insurance'])
         .where('acknowledge_admin_id', '==', '').limit(100)
    );
    return ref.snapshotChanges();
  }
  getOrderNotificationForPage() {
    let ref = this.firestore.collection(this.collectionName.AdminNotifications, (ref) =>
      ref.where('type', 'in', ['order', 'mark_default_address', 'benefit', 'update_benefits_auto', 'update_benefits_manual', 'private_insurance'])
         .where('acknowledge_admin_id', '==', '')
    );
    return ref.snapshotChanges();
  }

  getAdminNotifications() {
    let ref = this.firestore.collection(this.collectionName.AdminNotifications, (ref) =>
      ref.where('type', 'in', [
        'multiple_profile_management',
        'new_user_registration',
      ]).limit(100)
    );
    return ref.snapshotChanges();
  }
  getAdminNotificationsForPage() {
    let ref = this.firestore.collection(this.collectionName.AdminNotifications, (ref) =>
      ref.where('type', 'in', [
        'multiple_profile_management',
        'new_user_registration',
      ])
    );
    return ref.snapshotChanges();
  }

  /*** update RenewRefill data from firebase ***/
  updateAdminNotifications(itme: any) {
    let currentDate = new Date();
    let convertDate =
      this.helperService.convertDashDate(currentDate) +
      ', ' +
      this.helperService.getTime(currentDate);
    this.firestore.collection(this.collectionName.AdminNotifications).doc(itme.id).update({
      acknowledge_admin_name: itme.updatedByUserName,
      updatedBy: convertDate,
      acknowledge_admin_id: itme.updatedByUserId,
    });
  }

  //login start
  /**
   * update token in firebase database
   *
   * @param userId userId as a key
   * @param token token as a value
   */
  updateToken(userId: any, token: any) {
    // we can change this function to request our backend service
    this.afAuth.authState.pipe(take(1)).subscribe(() => {
      const data: any = {};
      data[userId] = token;
      this.angularFireDB.object('fcmTokens/').update(data);
    });
  }

  /**
   * request permission for notification from firebase cloud messaging
   *
   * @param userId userId
   */
  requestPermission(userId: any) {
    this.angularFireMessaging.requestToken.subscribe((token) => {
      this.updateToken(userId, token);
    });
  }

  /**
   * hook method when new notification received in foreground
   */
  receiveMessage() {
    this.angularFireMessaging.messages.subscribe((payload: any) => {
      this.currentMessage.next(payload);
    });
  }
  logFirestoreConfiguration() {
    // Log the current Firestore configuration
    console.log(
      'Firestore configuration:',
      this.firestore.firestore.app.options
    );
  }


  getPendingMessages(): Observable<any[]> {

    //this.logFirestoreConfiguration()
    const dataObservable = this.firestore
      .collection(this.collectionName.Chats, (ref) =>
        ref
          .where('fromAdmin', '==', false)
          .where('isRead', '==', false)
          .where('created_at', '>=', this.activeChatsMinCreatedAt)
          .orderBy('created_at', 'desc')
          .limit(100)
      )
      .valueChanges();

    return dataObservable;
  }
  getRecentMessages(): Observable<any[]> {
    const pendingMessage = this.firestore
      .collection(this.collectionName.Chats, (ref) =>
        ref
          .where('fromAdmin', '==', false)
          .where('isRead', '==', false)
          .where('created_at', '>=', this.activeChatsMinCreatedAt)
          .orderBy('created_at', 'desc')
          .limit(100)
      )
      .valueChanges();

    const dataObservable = this.firestore
      .collection(this.collectionName.Chats, (ref) =>
        ref
          .where('fromAdmin', '==', false)
          .where('isRead', '==', true)
          .where('created_at', '>=', this.activeChatsMinCreatedAt)
          .orderBy('created_at', 'desc')
          .limit(100)
      )
      .valueChanges();

    return combineLatest([pendingMessage, dataObservable]).pipe(
      map(([pendingMessages, allMessages]) => {
        const pendingMessagesArray = pendingMessages as any[]; // Type assertion
        const allMessagesArray = allMessages as any[]; // Type assertion

        const userIds = pendingMessagesArray.map(message => message?.userId || 0);
        const filteredMessages = allMessagesArray.filter(message => !userIds.includes(message.userId));
        return filteredMessages;
      })
    );
  }
  getRecentAndPendingMessages(): Observable<{
    pendingMessages: any[];
    recentMessages: any[];
    uniqueUserIds: any[];
  }> {
    // Single source query for dashboard chat cards:
    // pull a recent window of chats, then derive per-user latest state in-memory.
    // A user remains in Pending while any unread patient message exists,
    // even if an automated/admin message is sent afterwards.
    const dataObservable$ = this.firestore
      .collection(this.collectionName.Chats, (ref) =>
        ref
          //.where('isRead', '==', true)
          .where('created_at', '>=', this.activeChatsMinCreatedAt)
          .orderBy('created_at', 'desc')
          .limit(500)
      )
      .valueChanges().pipe(
        catchError((error) => {
          console.error('Error in dataObservable$: ', error);
          return of([]); // Return an empty array to allow the stream to continue
        })
      );

    return dataObservable$.pipe(
      map((allMessages: any[]) => {
        const latestMessageByUser: { [userId: string]: any } = {};
        const latestUnreadPatientMessageByUser: { [userId: string]: any } = {};

        // Keep the latest conversation message and latest unread patient message per user.
        // Preserve original Firestore timestamp in `created_at_with_time`.
        allMessages.forEach((message) => {
          if (!message || message.userId === null || message.userId === undefined) {
            return;
          }

          message.created_at_with_time = cloneDeep(message.created_at);
          message.created_at = cloneDeep(this.convertFirestoreTimestamp(message.created_at));

          const userId = String(message.userId);
          if (
            !latestMessageByUser[userId] ||
            message.created_at > latestMessageByUser[userId].created_at
          ) {
            latestMessageByUser[userId] = message;
          }

          if (message.fromAdmin === false && message.isRead === false) {
            if (
              !latestUnreadPatientMessageByUser[userId] ||
              message.created_at > latestUnreadPatientMessageByUser[userId].created_at
            ) {
              latestUnreadPatientMessageByUser[userId] = message;
            }
          }
        });

        const uniquePendingMessages: any[] = [];
        const uniqueRecentMessages: any[] = [];

        Object.keys(latestMessageByUser).forEach((userId) => {
          if (latestUnreadPatientMessageByUser[userId]) {
            // Keep in pending while unread patient message exists.
            uniquePendingMessages.push(latestUnreadPatientMessageByUser[userId]);
          } else {
            uniqueRecentMessages.push(latestMessageByUser[userId]);
          }
        });

        const uniqueUserIds = Object.keys(latestMessageByUser).map((userId) => ({ userId }));

        return {
          pendingMessages: uniquePendingMessages,
          recentMessages: uniqueRecentMessages,
          uniqueUserIds: uniqueUserIds,
        };
      })
    );
  }


  convertFirestoreTimestamp(timestamp: any): Date {
    if (timestamp && timestamp.seconds) {
      // Firestore timestamp to JavaScript Date
      return new Date(timestamp.seconds * 1000 + Math.floor(timestamp.nanoseconds / 1000000));
    }
    return timestamp; // Default to Epoch time if timestamp is invalid
  }

  async getLastChatMessages() {
    const seconds = 1731573865;
    const nanoseconds = 582000000;
    const userId = 170407853;

    // Use firebase.firestore.Timestamp to create a Timestamp
    const timestamp = new firebase.firestore.Timestamp(seconds, nanoseconds);

    const lastMessageDoc = await this.firestore.collection(this.collectionName.Chats, (ref) =>
      ref
        .where('userId', '==', Number(userId))
        .where('email', '==', "a87@yopmail.com")
        .where('message', '==', "29")
        .where('created_at', '==', timestamp)
        .limit(1)
    ).get().toPromise();

    // Agar document milta hai to data return karein, warna null
    if (!lastMessageDoc?.empty) {
        const docData = lastMessageDoc?.docs[0].data(); // Get the document data

        // Query to get previous messages based on the last document
        let query = this.firestore.collection(this.collectionName.Chats, (ref) =>
          ref
            .where('userId', '==', Number(userId))
            .orderBy('created_at', 'desc')
            .limit(10)
            .startAfter(lastMessageDoc?.docs[0]) // Use last document for endBefore condition
        );

        // Resolving the query promise and logging the result
        const querySnapshot = await query.get().toPromise();
        console.log('Fetched previous chat messages:', querySnapshot?.docs.map(doc => doc.data()));

        return docData; // Return the last document data
    } else {
        return null; // Return null if no document found
    }
}

getChatMessages(
  userId: string,
  limit: number = 10,
  lastVisibleMessage: any
): Observable<{ allMessages: any[], lastMessage: any, firstMessage: any, messageCount: number }> {

      return this.firestore.collection(this.collectionName.Chats, (ref) => {
        let baseQuery = ref
          .where('userId', '==', Number(userId))
          .where('created_at', '>=', this.activeChatsMinCreatedAt)
          .orderBy('created_at', 'desc')
          //.startAfter(staticTimestamp)
          .limit(limit);
          //console.log('messagesmessages', this.lastVisibleMessageSr);
        if (lastVisibleMessage && lastVisibleMessage.created_at){
          const timestamp = new firebase.firestore.Timestamp(lastVisibleMessage.created_at.seconds, lastVisibleMessage.created_at.nanoseconds);
          baseQuery = baseQuery.endBefore(timestamp);
        }

        return baseQuery;
      }).valueChanges().pipe(
    map((messages: any[]) => {
      if (messages.length > limit) {
        messages.pop(); // Remove the last message that exceeds the limit
      }
      const lastMessage = messages.length > 0 ? messages[messages.length - 1] : null;
      const firstMessage = messages.length > 0 ? messages[0] : '';
      //console.log('lastMessage', messages);
      return { allMessages: messages, lastMessage , firstMessage, messageCount: messages.length};
    })
  );
}


loadMoreChatMessages(
  userId: string,
  limit: number = 10,
  lastVisibleMessage?: any
): Observable<{ allMessages: any[], lastMessage: any }> {

  let query: any = this.firestore.collection(this.collectionName.Chats, (ref) => {
    let baseQuery = ref
    .where('userId', '==', Number(userId))
    .where('created_at', '>=', this.activeChatsMinCreatedAt)
    .orderBy('created_at', 'desc')
    .limit(limit)
    .startAfter(lastVisibleMessage)

    if (lastVisibleMessage && lastVisibleMessage.created_at) {
      baseQuery = baseQuery.startAfter(lastVisibleMessage.created_at);
    }

    return baseQuery;
  });

// Execute the query
return from(query.get() as Promise<QuerySnapshot<any>>).pipe(
  map((snapshot) => {
    const messages = snapshot.docs.map((doc: QueryDocumentSnapshot<any>) => doc.data());
    if (messages.length > limit) {
      messages.pop();
    }
    const lastMessage = messages.length > 0 ? messages[messages.length - 1] : null;
    return { allMessages: messages, lastMessage };
  })
);
}


  sendMessage(chatMessage: any): Promise<void> {
    // Step 1: Create a blank message

   // this.logFirestoreConfiguration();
    let newMessage = this.firestore.collection(this.collectionName.Chats).doc() as AngularFirestoreDocument<DocumentType>;
    //console.log("Document successfully created with ID: ", newMessage.ref.id);
    return newMessage.set(chatMessage);
}

  updateMessage(chatMessage: any): Promise<void> {
    // Step 4: Update the message with the required data
    return this.firestore.collection(this.collectionName.Chats).doc(chatMessage.id).set(chatMessage);
  }
  markMessagesAsReadOrUnread(userId: number,limit: number,isRead : boolean): Promise<void> {

    // Query the collection for pending messages associated with the userId
    let isReadStatus = true;
    if(isRead){
      isReadStatus = false;
    }
    return this.firestore.collection(this.collectionName.Chats, ref =>
        ref.where('userId', '==', Number(userId))
          .where('fromAdmin', '==', false)
          .where('isRead', '==', isReadStatus)
          .orderBy('created_at', 'desc')
          .limit(limit)
      )
      .get()
      .toPromise()
      .then((querySnapshot) => {
        // Iterate through the documents and update isRead field to true
        const batch = this.firestore.firestore.batch();
        querySnapshot?.forEach((doc) => {
          const messageRef = doc.ref;
          batch.update(messageRef, { isRead: isRead });
        });
        // Commit the batched updates
        return batch.commit();
      });
  }

  getCurrentTimestamp(): Timestamp {
    const currentDateTime = new Date();
    const timestamp = firebase.firestore.Timestamp.fromDate(currentDateTime);
    return timestamp;
  }
}
